import { get } from 'axios';
import { message } from 'antd';

const userInfo = {
  state: null,

  reducers: {
    clearUserInfo() {
      localStorage.removeItem('user:userInfo');
      return null;
    },

    setUserInfo(state, payload) {
      return {
        ...state,
        ...payload
      }
    }
  },

  effects: (dispatch) => ({
    async getUserInfo(_payload, rootState) {
      const userInfo = JSON.parse(localStorage.getItem('user:userInfo'));
      if (userInfo !== null) {
        dispatch.userInfo.setUserInfo(userInfo);
        return;
      }

      const { loginInfo } = rootState;
      if (loginInfo.access_token === '') {
        return;
      }

      await dispatch.userInfo.refreshUserInfo();
    },

    async refreshUserInfo() {
      try {
        const { data } = await get('user/get-info');
        if (data.error_code !== 0) {
          message.error(data.message);
        } else {
          dispatch.userInfo.setUserInfo(data.data);
          localStorage.setItem('user:userInfo', JSON.stringify(data.data));
        }
      } catch (err) {
        throw err;
      }
    }
  })
}

export default userInfo;
